import { useEffect } from 'react';
import {  useLocation, useNavigate } from 'react-router-dom';

const Confirmation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { card, response } = location.state;

    // Function to format the date and time
    const formatDateTime = (timestamp) => {
        const date = new Date(timestamp * 1000);
        const options = { dateStyle: 'long', timeStyle: 'medium' };
        return date.toLocaleString(undefined, options);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/');
        }, 3000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <>


            <div className="flex flex-col justify-center items-center"  style={{height: "calc(100% - 64px)"}}>
                <div className="bg-darkgrey shadow-popup rounded-8 w-3/5 p-4 mx-20 font-primary">
                    <table className="min-w-ful text-[24px]">
                        <tbody>
                        <tr className="">
                            <td className="text-textDark font-light px-2 py-1">
                                {response.user_type === 'guest' ? 'Guest Name:' : 'Staff Member:'}
                            </td>
                            <td className="font-bold px-2 py-1">
                                {card.first_name} {card.last_name}
                            </td>
                        </tr>
                        <tr className="">
                            <td className="text-textDark font-light px-2 py-1">
                                Registered:
                            </td>
                            <td className="font-bold px-2 py-1">
                                {response.event_type === 'check_in' ? 'IN' : 'OUT'}
                            </td>
                        </tr>
                        <tr className="">
                            <td className="text-textDark font-light px-2 py-1">
                                Date / Time:
                            </td>
                            <td className="font-bold px-2 py-1">
                                {formatDateTime(response.timestamp)}
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </div>
                <h1 className="flex items-center gap-[32px] text-[148px] font-medium mb-4 font-primary mt-10 md:text-[106px]">Thank
                    You! <img
                        src='/resources/images/smile.png'
                        className="size-40 md:size-36"
                        alt='Back'
                    /></h1>
            </div>

        </>
    );
};

export default Confirmation;